<template>
  <div class="slide-content">
    <div class="resize-body">
      <div class="resize-content" :style="`transform: translate(-50%,-50%) scale(${scaling})`">
        <div class="title-content">
          <img src="../../../assets/image/kjqg/index/bnkj/bnkj.png" class="zcqd-title" alt="">
        </div>
        <div class="bnkj-info">
          <div class="bnkj-item type1" style="top: 0; left: 0;" @click="toList(2)">
            <div class="item-cover"></div>
          </div>
          <div class="bnkj-item type2" style="top: 0; right: 0;" @click="toList(3)">
            <div class="item-cover"></div>
          </div>
          <div class="bnkj-item type2" style="bottom: 0; left: 13px;" @click="toList(0)">
            <div class="item-cover"></div>
          </div>
          <div class="bnkj-item type3" style="bottom: 16px; right: 0;" @click="toList(1)">
            <div class="item-cover"></div>
          </div>
        </div>
        <div class="more" @click="toMoreList()">查看更多</div>
      </div>
    </div>

  </div>
</template>

<script>
import services from "../../../assets/js/services.js"
import { mapActions } from "vuex";
export default {
  props: ["scaling"],
  mounted() {

  },

  data() {
    return {
      specialId: services.KJQG_SPECIAL_ID,
      school_code: localStorage.getItem("schoolCode"),
    }
  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin"]),
    toMoreList() {
      this.goAppsDetailsBeforeLogin().then(() => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/bnkjhz?ind=0`,
        });
        window.open(routeUrl.href, "_blank");
      });

    },
    toList(ind) {
      this.goAppsDetailsBeforeLogin().then((res) => {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/kjqg/bnkjhz?ind=${ind}`
        })
         window.open(routeUrl.href, "_blank");
      });
    }
  }
}
</script>

<style lang="less" scoped>
.slide-content {
  padding-top: 5.16vw;

  background-size: cover;
  background-position: center;
  height: 100%;
  position: relative;
  .resize-body {
    position: relative;
    width: 100%;
    height: 100%;
    .resize-content {
      // height: 100%;
      width: 1920px;
      transform-origin: center center;
      height: 981px;
      position: absolute;
      top: 50%;
      left: 50%;
      .title-content {
        // margin: 0 auto;
        text-align: center;
        .zcqd-title {
          max-width: 580px;
          margin-top: 30px;
        }
      }
      .bnkj-info {
        width: 1391px;
        height: 688px;
        margin: 50px auto 0;
        position: relative;
        &::before {
          display: block;
          content: "";
          width: 523px;
          height: 526px;
          background-image: url("../../../assets/image/kjqg/index/bnkj/bnkj-bg.png");
          background-size: cover;
          background-repeat: no-repeat;
          position: absolute;
          top: 77px;
          left: 439px;
          z-index: 11;
        }

        .bnkj-item {
          position: absolute;
          cursor: pointer;
          &:hover {
            transform: scale(1.1);
            transition: all .3s;
          }
          &:nth-child(1) {
            .item-cover {
              background-image: url("../../../assets/image/kjqg/index/bnkj/item-1.png");
            }
          }
          &:nth-child(2) {
            .item-cover {
              background-image: url("../../../assets/image/kjqg/index/bnkj/item-2.png");
            }
          }
          &:nth-child(3) {
            .item-cover {
              background-image: url("../../../assets/image/kjqg/index/bnkj/item-3.png");
            }
          }
          &:nth-child(4) {
            .item-cover {
              background-image: url("../../../assets/image/kjqg/index/bnkj/item-4.png");
            }
          }
          .item-cover {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
          }
          &.type1 {
            width: 570px;
            height: 334px;
            // border: 4px solid #ffffff;
          }
          &.type2 {
            width: 435px;
            height: 264px;
            // background-image: url("../../../assets/image/kjqg/index/bnkj/item-bg.png");
            background-size: cover;
          }
          &.type3 {
            width: 533px;
            height: 318px;
            border: 4px solid #ffffff;
          }
        }
      }
      .more {
        width: 148px;
        height: 47px;
        line-height: 47px;
        background-image: url("../../../assets/image/kjqg/index/xskj/more.png");
        background-size: cover;
        font-weight: 400;
        font-size: 16px;
        color: #0c6aef;
        text-align: center;
        margin: 50px auto 0;
        cursor: pointer;
      }
    }
  }
}
</style>